import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { koKR } from '@mui/x-date-pickers/locales';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import dayjs from 'dayjs';
import 'dayjs/locale/ko';
import styled from 'styled-components';

interface IProps {
  value: string;
  onChange: (value: string) => void;
}
const MapDatePicker = ({ value, onChange }: IProps) => {
  const onChangeInput = (value: any | unknown) => {
    if (!value) {
      return;
    }
    const year = value.$y;
    const month = value.$M + 1;
    const day = value.$D;
    const changedMonth = month < 10 ? `0${month}` : month;
    const changedDay = day < 10 ? `0${day}` : day;
    onChange(`${year}-${changedMonth}-${changedDay}`);
  };

  return (
    <LocalizationProvider
      dateAdapter={AdapterDayjs}
      adapterLocale="ko"
      localeText={koKR.components.MuiLocalizationProvider.defaultProps.localeText}
    >
      <CustomDateField
        value={dayjs(value)}
        format={'YYYY-MM-DD'}
        onChange={(newValue) => {
          onChangeInput(newValue);
        }}
      />
    </LocalizationProvider>
  );
};

const CustomDateField = styled(DatePicker)`
  display: flex;
  justify-content: center;

  .MuiInputBase-root {
    width: 148px;
    height: 30px;
    bottom: 0;
    border-radius: 0.3125rem;
    background: #006ac8;
    font-family: '' Inter '';
    font-style: normal;
    font-weight: 500;
    font-size: 15px;
    line-height: 18px;
    display: flex;
    align-items: center;
    text-align: center;
    letter-spacing: 0.03em;
    color: #ffffff;
    :focus {
      outline: 0;
    }
  }
  .MuiSvgIcon-root {
    color: #ffffff;
  }
  .MuiOutlinedInput-root fieldset {
    border: 0;
  }
  .MuiOutlinedInput-input {
    text-align: center;
  }
`;

export default MapDatePicker;
